<template>
    <div class="quiz-name">
        <flex-container class="mb-10" align="center">
            <PracticeTimerIcon
                class="mr-7"
                v-if="(quiz.options && quiz.options.timer_duration) || quizIncludesQuestionWithTimer()"
            />
            <p :style="getQuizStyle()">
                {{ quiz.name }}
            </p>
        </flex-container>
    </div>
</template>

<script>
import FlexContainer from "@components/Containers/FlexContainer.vue"
import PracticeTimerIcon from "@components/Practice/common/timer/PracticeTimerIcon.vue"
import { resolveFont } from "@components/Builder/widget/utils/style"

export default {
    props: {
        quiz: {
            type: Object,
            default: () => {}
        }
    },
    name: "PracticeQuizName",
    components: { PracticeTimerIcon, FlexContainer },
    methods: {
        getQuizStyle() {
            return {
                ...resolveFont(this?.quiz.style?.layout?.fontQuizName)
            }
        },
        quizIncludesQuestionWithTimer() {
            if (!this.quiz) {
                return false
            }
            return !!this.quiz.questions.find(q => q.timer)
        }
    }
}
</script>

<style scoped lang="sass">

</style>
